import { useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
// import ExampleCarouselImage from 'components/ExampleCarouselImage';
import { routerPath } from "../../../../navigation/path";
import { useNavigate } from 'react-router-dom';


const CustomCarousel = ({
    images = []
}) => {
    const navigate = useNavigate()
    const handleRoute = (offerId) => {
        offerId ? navigate(`${routerPath.claimOffer}?offer_id=${offerId}`) : console.log('Offer id Is Null')
    }
    return (
        <Carousel>
            {images.map((item, index) => (
                <Carousel.Item key={index} interval={1000} onClick={() => handleRoute(item.offer_id)}>
                    <img src={item?.image} alt={`Slide ${index + 1}`} className='w-full h-[427px] cursor-pointer' />
                    {/* <Carousel.Caption>
                        <h3>Slide {index + 1} label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    </Carousel.Caption> */}
                </Carousel.Item>
            ))}
        </Carousel>

    )
}

export default CustomCarousel